<template>
    <KForm
        id="bankid-form"
        :errors="errors"
        :submit-content="submitButton"
        actionsAlign="center"
        @submit="submit"
        @cancel="cancel"
    >
    </KForm>
</template>

<script setup>
    import { toRefs } from "vue";
    import KForm from "@/components/forms/Form/KForm.vue";

    const props = defineProps({
        errors: {
            type: Object,
            default: () => ({}),
        },
        submitButton: {
            type: String,
            default: "",
        },
        personnummer: {
            type: String,
            default: null,
        },
    });

    const { errors, submitButton } = toRefs(props);

    const emit = defineEmits(["submit", "error", "cancel"]);

    const submit = async (formData) => {
        emit("submit", formData);
    };

    const cancel = () => {
        emit("cancel");
    };
</script>
